import {
  DISPLAY_TOURNAMENTS,
  START_LOADING_TOURNAMENTS,
  SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS,
  UPDATE_SHOW_ALL_TOURNAMENTS,
  DISPLAY_GROUP_NAME
  } from './constants';

export const initialState = {
  entries: [],
  searchValue: '',
  activeTournamentCount: undefined,
  loadingTournaments: false,
  showAllTournaments: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case DISPLAY_TOURNAMENTS: {
    let activeTournamentCount = state.activeTournamentCount;

    if (payload.entries && !activeTournamentCount) activeTournamentCount = payload.entries.length;
    return {
      ...state,
      ...payload,
      activeTournamentCount: activeTournamentCount,
      loadingTournaments: false
    };
  }
  case START_LOADING_TOURNAMENTS:
    return {
      ...state,
      loadingTournaments: true,
      entries: []
      };  

  case SET_SEARCH_TOURNAMENT_VALUE_FOR_TOURNAMENTS:
    return {
      ...state,
      searchValue: payload.searchValue || initialState.searchValue
    };

  case UPDATE_SHOW_ALL_TOURNAMENTS:
    return {
      ...state,
      showAllTournaments: payload
    };

  case DISPLAY_GROUP_NAME:
    return {
      ...state,
      groupName: payload
    };

  default:
    return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/reducer.js